import { useTitle } from 'contexts/TitleContext'
import PropTypes from 'prop-types'
import { useEffect } from 'react'

export default function ColumnFilter({ column }) {
  // Desestructuración de propiedades relevantes de 'column'
  const { filterValue, setFilter } = column

  // Obtiene el valor de filtro previo guardado en localStorage
  const previousFilter = localStorage.getItem(column.id)

  // Accede al contexto de título para posibles actualizaciones relacionadas
  const { title } = useTitle()

  // useEffect para guardar el valor actual del filtro en localStorage cuando este cambia
  useEffect(() => {
    localStorage.setItem(column.id, filterValue)
  }, [previousFilter, filterValue])

  // useEffect para cargar el filtro anterior al montarse el componente o cambiar el título
  useEffect(() => {
    if (previousFilter !== 'undefined') {
      setFilter(previousFilter)
    }
  }, [title])

  return (
    <div className="print:hidden">
      <input
        type="text"
        className={`w-full py-1 pr-1 border border-gray-200 focus:ring-opacity-20 focus:outline-none focus:ring focus:border-[#006F53] focus:ring-[#4a9e7e] dark:focus:border-[#4a9e7e] hover:border-[#4a9e7e] rounded-sm px-1 text-gray-400 text-sm`}
        placeholder="Filtrar..."
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => setFilter(e.target.value)}
        value={filterValue || ''}
      />
    </div>
  )
}

// Define los tipos de las props que recibe el componente actual
ColumnFilter.propTypes = {
  column: PropTypes.object.isRequired
}
